import React, { useState } from 'react'
import PropTypes from 'prop-types'
import RoadmapV2 from 'model/carePlans/carePlan'
import CostEstimationModal from 'components/CostEstimationModal'
import FacilityList from './FacilityList'
import ProviderList from './ProviderList'
import useEntities from '../../hooks/useEntities'
import { CardWithMargin } from './styled'

const CareEntitySection = ({ carePlan, setLoading }) => {
  const { member, isFacility } = carePlan
  const [visible, setVisible] = useState(false)
  const [selectedEntity, setSelectedEntity] = useState({})

  const onSelectEntity = entity => {
    setSelectedEntity(entity)
    setVisible(true)
  }

  const { entities, loading, onRemoveEntity, onSaveEntity } = useEntities(
    carePlan,
    setVisible,
    selectedEntity,
    setLoading,
    member?.id
  )

  const onEditEntity = entityId => {
    const entity = entities.find(({ id }) => id === entityId)
    setVisible(true)
    onSelectEntity(entity)
  }

  const onCancel = () => setVisible(false)

  return (
    <CardWithMargin
      title={isFacility ? 'Facilities' : 'Providers'}
      type="inner"
    >
      {isFacility ? (
        <FacilityList
          facilities={entities}
          onRemoveFacility={onRemoveEntity}
          onEditFacility={onEditEntity}
        />
      ) : (
        <ProviderList
          doctor_items={entities}
          onRemoveDoctor={onRemoveEntity}
          onEditDoctor={onEditEntity}
        />
      )}
      {visible && (
        <CostEstimationModal
          entity={selectedEntity}
          member_id={member?.id}
          isFacility={isFacility}
          visible
          showNotes
          loading={loading}
          onCancel={onCancel}
          onSave={onSaveEntity}
        />
      )}
    </CardWithMargin>
  )
}

CareEntitySection.propTypes = {
  carePlan: PropTypes.shape(RoadmapV2.shape).isRequired,
  setLoading: PropTypes.func
}

export default CareEntitySection
